/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type UtxDataWarehouseGetAssetBalanceSummaryDisplayCurrency = typeof UtxDataWarehouseGetAssetBalanceSummaryDisplayCurrency[keyof typeof UtxDataWarehouseGetAssetBalanceSummaryDisplayCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UtxDataWarehouseGetAssetBalanceSummaryDisplayCurrency = {
  HKD: 'HKD',
  USD: 'USD',
} as const;
